import React from 'react';
import { BoltIcon, ShieldCheckIcon, SparklesIcon } from '@heroicons/react/24/outline';
import loginBackground from '../../../assets/login_background.webp';
import Brand from './Brand';

const FEATURES = [
  { Icon: BoltIcon, text: 'Automatic transcription with multiple providers' },
  { Icon: SparklesIcon, text: 'Speaker diarization and editable transcript blocks' },
  { Icon: ShieldCheckIcon, text: 'Secure SSO and access controlled by your organization' },
];

/** The illustrated side panel of the login page: brand, pitch and feature list. */
export default function LoginShowcase() {
  return (
    <aside
      className="login-aside"
      style={{ '--login-bg': `url(${loginBackground})` }}
    >
      <div className="login-aside-bg" aria-hidden="true" />
      <div className="login-aside-overlay" aria-hidden="true" />

      <Brand size="lg" />

      <div className="login-aside-content">
        <span className="login-aside-eyebrow">
          <span className="login-aside-eyebrow-dot" aria-hidden="true" />
          AI Transcript Platform
        </span>
        <h2 className="login-aside-title">
          Transcripts, reports and insights — in one quiet place.
        </h2>
        <p className="login-aside-sub">
          Upload audio or video and let Diplo AI turn it into searchable,
          speaker‑attributed transcripts and structured session reports.
        </p>

        <div className="login-aside-features">
          {FEATURES.map(({ Icon, text }) => (
            <div key={text} className="login-aside-feature">
              <Icon />
              <span>{text}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="login-aside-foot">
        © {new Date().getFullYear()} DiploFoundation
      </div>
    </aside>
  );
}
